import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { STATUS_ON, STATUS_OFF, STATUS_LOADING } from '../../constants/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSpinnerThird,
  faFile,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

const ToolbarButton = ({
  status,
  enabled,
  icon,
  iconComponent,
  handleClick,
  ariaLabel,
}) => {
  let variant = 'sidebar';
  if (status === STATUS_LOADING) {
    icon = faSpinnerThird;
  }
  if (status === STATUS_ON || status === STATUS_LOADING) {
    variant = 'wb';
  }

  // If icon component is specified, use it
  if (iconComponent) {
    const IconComponent = iconComponent;
    return (
      <Button
        title={enabled ? null : 'Disabled for this tool'}
        disabled={!enabled}
        variant={variant}
        onClick={enabled ? handleClick : null}
        aria-label={ariaLabel}
        aria-pressed={status === STATUS_ON || status === STATUS_LOADING}
      >
        <IconComponent
          spin={status === STATUS_LOADING}
          width={16}
          height={16}
        />
      </Button>
    );
  }

  // Otherwise, we expect an icon to have been specified
  return (
    <Button
      title={enabled ? null : 'Disabled for this tool'}
      disabled={!enabled}
      variant={variant}
      onClick={enabled ? handleClick : null}
      aria-label={ariaLabel}
      aria-pressed={status === STATUS_ON || status === STATUS_LOADING}
    >
      <FontAwesomeIcon
        icon={icon}
        spin={status === STATUS_LOADING}
        width={16}
        height={16}
      />
    </Button>
  );
};

ToolbarButton.propTypes = {
  status: PropTypes.number,
  enabled: PropTypes.bool,
  icon: PropTypes.object,
  handleClick: PropTypes.func,
  ariaLabel: PropTypes.string,
};
ToolbarButton.defaultProps = {
  icon: faFile,
  status: STATUS_OFF,
  enabled: false,
};

export default ToolbarButton;
